import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { QUOTATION_ACCORDION_CONTENT } from '../../utils/constans/quotationAccordionContent';
import { QuotationData } from '../../models/quotations/Quotations';

export const QuotationEditorWrapper = (props: {
    quote?: QuotationData;
    refetch: () => void;
}) => {
    const { quote, refetch } = props;

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.ACCORDION_TITLES',
    });

    const [expanded, setExpanded] = React.useState<string | false>(
        'quotation_details'
    );
    const [currentQuoteData, setCurrentQuoteData] =
        useState<QuotationData>(quote);

    useEffect((): void => setCurrentQuoteData(quote), [quote]);

    const handleChange =
        (panel: string) =>
        (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const handleNext = (index: number, updateItems?: any) => {
        if (updateItems) {
            setCurrentQuoteData({ ...currentQuoteData, ...updateItems });
        }

        setExpanded(QUOTATION_ACCORDION_CONTENT[index + 1].id);
    };

    return (
        <>
            {QUOTATION_ACCORDION_CONTENT.map((item, index) => (
                <Accordion
                    key={item.id}
                    expanded={expanded === item.id}
                    onChange={handleChange(item.id)}
                    sx={{ border: '1px solid #ececec', marginBottom: '10px' }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id={item.id + '-header'}
                    >
                        <Typography variant={'h3'}>{t(item.title)}</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={{ backgroundColor: '#f4f4f4', padding: '10px' }}
                    >
                        {expanded == item.id && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                {React.createElement(item.component, {
                                    handleNext: handleNext,
                                    index: index,
                                    quoteData: currentQuoteData,
                                    updateProducts: refetch,
                                })}
                            </Box>
                        )}
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    );
};
